export default "__VITE_ASSET__wJ7exm50__"